import React, { Component } from 'react';

export class DatePickerSelectors extends Component {
  constructor(props) {
    super(props);
    this.monthsBefore = [];
    this.monthsAfter = [];
    this.months = {
      0: 'Enero',
      1: 'Febrero',
      2: 'Marzo',
      3: 'Abril',
      4: 'Mayo',
      5: 'Junio',
      6: 'Julio',
      7: 'Agosto',
      8: 'Septiembre',
      9: 'Octubre',
      10: 'Noviembre',
      11: 'Diciembre',
      12: 'Enero',
    };
  }

  componentDidMount() {
    const currentMonth = new Date().getMonth();
    const currentYear = new Date().getFullYear();

    this.monthsBefore = this.getMonthsBefore(currentMonth, currentYear, this.months);
    this.monthsAfter = this.getMonthsAfter(currentMonth, currentYear, this.months);
  }

  formatLabelValue = (fromStore = null) => {
    if (fromStore) {
      const date = new Date(fromStore);
      return `${this.months[date.getMonth()]} - ${date.getFullYear()}`;
    }
    return '';
  }


  getMonthsBefore = (currentMonth, currentYear, months) => {
    const monthsBefore = [];
    // eslint-disable-next-line guard-for-in, no-restricted-syntax
    for (const i in months) {
      const monthIndex = currentMonth - Number(i);
      if (monthIndex >= 0) {
        monthsBefore.push({
          day: '01',
          month: `${monthIndex + 1}`.length < 2 ? `0${monthIndex + 1}` : `${monthIndex + 1}`,
          year: `${currentYear}`,
          label: `${months[monthIndex]} - ${currentYear}`,
        });
      } else {
        monthsBefore.push({
          day: '01',
          month: `${monthIndex + 13}`.length < 2 ? `0${monthIndex + 13}` : `${monthIndex + 13}`,
          year: `${currentYear - 1}`,
          label: `${months[monthIndex + 12]} - ${currentYear - 1}`,
        });
      }
    }
    return monthsBefore;
  };

  getMonthsAfter = (currentMonth, currentYear, months) => {
    const monthsAfter = [];
    const getLastDayOfMonth = (year, month) => (`${new Date(year, month + 1, 0).getDate()}`);
    // eslint-disable-next-line guard-for-in, no-restricted-syntax
    for (const i in months) {
      const monthIndex = currentMonth + Number(i);
      if (monthIndex < 12) {
        monthsAfter.push({
          day: getLastDayOfMonth(currentYear, monthIndex),
          month: `${monthIndex + 1}`.length < 2 ? `0${monthIndex + 1}` : `${monthIndex + 1}`,
          year: `${currentYear}`,
          label: `${months[monthIndex]} - ${currentYear}`,
        });
      } else {
        monthsAfter.push({
          day: getLastDayOfMonth(currentYear + 1, monthIndex - 12),
          month: `${monthIndex - 11}`.length < 2 ? `0${monthIndex - 11}` : `${monthIndex - 11}`,
          year: `${currentYear + 1}`,
          label: `${months[monthIndex - 12]} - ${currentYear + 1}`,
        });
      }
    }
    return monthsAfter;
  };

  render() {
    const {
      handleSelectorBefore = () => {},
      handleSelectorAfter = () => {},
      slctDateAfterStore = '',
      slctDateBeforeStore = '',
    } = this.props;

    return (
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: '30px' }}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '12px' }}>
          <p style={{ fontSize: '14px', fontWeight: '300', margin: '0' }}>
            De:
          </p>
          <select
            className="datePicketSelectorClass"
            style={{
              height: '40px',
              boxShadow: '0 0 2px rgb(204, 204, 204)',
              border: '1px solid #d8d8d8',
              borderRadius: '3px',
              padding: '5px',
            }}
            ref={input => this.props.handleSelectorDateBefore(input)}
            onChange={value => handleSelectorBefore(value)}
          >
            {
              this.monthsBefore.map((month, index) => {
                if (index === 0) {
                  return (
                    <option
                      selected
                      value={this.getMonthsBefore(slctDateBeforeStore) || `${month.year}/${month.month}/${month.day}`}
                    >
                      {this.formatLabelValue(slctDateBeforeStore) || month.label}
                    </option>
                  );
                }
                return (
                  <option
                    value={`${month.year}/${month.month}/${month.day}`}
                  >
                    {month.label}
                  </option>
                );
              })
            }
          </select>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex - start', gap: '12px' }}>
          <p style={{ fontSize: '14px', fontWeight: '300', margin: '0' }}>
            A:
          </p>
          <select
            className="datePicketSelectorClass"
            style={{
              height: '40px',
              boxShadow: '0 0 2px rgb(204, 204, 204)',
              border: '1px solid #d8d8d8',
              borderRadius: '3px',
              padding: '5px',
            }}
            onChange={value => handleSelectorAfter(value)}
            ref={input => this.props.handleSelectorDateAfter(input)}
          >
            {
              this.monthsAfter.map((month, index) => {
                if (index === 2) {
                  return (
                    <option
                      selected
                      value={slctDateAfterStore || `${month.year}/${month.month}/${month.day}`}
                    >
                      {this.formatLabelValue(slctDateAfterStore) || month.label}
                    </option>
                  );
                }
                return (
                  <option
                    value={`${month.year}/${month.month}/${month.day}`}
                  >
                    {month.label}
                  </option>
                );
              })
            }
          </select>
        </div>
      </div>
    );
  }
}
